import { createFileRoute } from '@tanstack/react-router';
import { UserManagementPage } from '../../pages';
import { PagesProvider } from '../../pages/providers/pages-provider';
import { beforeLoadAuthenticatedValidation } from '../../router';
import { NavbarPageTemplate } from '../../templates';

export const Route = createFileRoute('/_authenticated/org-user-management')({
  staticData: {
    pageName: 'User Management',
  },
  beforeLoad: ({ context, location }) => beforeLoadAuthenticatedValidation(context, location),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PagesProvider template={NavbarPageTemplate} templateProps={{ currentRoute: '/org-user-management' }}>
      <UserManagementPage />
    </PagesProvider>
  );
}
